import React from 'react';

import Spinner from '../../../components/Spinner';

import LessonContainer from './LessonContainer';

const LessonSpinner = () => (
    <LessonContainer>
        <div className="card-panel spinner-wrapper">
            <Spinner className="lesson-spinner" />
        </div>
    </LessonContainer>
);

export default LessonSpinner;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonSpinner.js